import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { PreviewPage } from './PreviewPage';
import { PreviewPageData } from './PreviewPageData';
import reportWebVitals from './reportWebVitals';

// 1. 读取 URL 参数
const urlParams = new URLSearchParams(window.location.search);
const previewId = urlParams.get('id');
const previewData = urlParams.get('page'); // 如果你还支持旧格式

// 2. 根据参数决定渲染哪个组件
const RootComponent = () => {
  if (previewId) {
    return <PreviewPage previewId={previewId} />;
  }
  if (previewData) {
    return <PreviewPageData previewData={previewData} />;
  }
  return <App />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <App /> */}
    <RootComponent />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
